module.exports = __webpack_public_path__ + "media/chat.a28cf884.mp3";